import { useDispatch, useSelector } from 'react-redux'
import { orderBy, isEmpty } from 'lodash'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'

import Pagination from 'components/Pagination'
import ListItem from 'components/Merchants/ListItem'
import Section from 'components/Section'
import MerchantsForm from 'components/Merchants/Form'
import Loader from 'components/Loader'

import {
  getMerchants,
  getAllMerchantsCount,
  getIsMerchantsLoading,
} from 'store/Merchants/selectors'
import { getQueryStringParameters } from 'store/AppState/selector'
import { getCurrentVenueUuid } from 'store/Venues/selector'
import { setQueryStringParameters } from 'store/AppState/actions'
import { fetchMerchants } from 'store/Merchants/actions'

const MerchantsList = () => {
  const { pathname, state: urlQueryParamsState } = useLocation()
  const dispatch = useDispatch()

  const merchants = useSelector(getMerchants)

  const venueUuid = useSelector(getCurrentVenueUuid)
  const queryStringParameters = useSelector((state) =>
    getQueryStringParameters(state, pathname)
  )
  const queryStringParametersWithVenue = {
    ...queryStringParameters,
    venueUuid,
  }

  const totalMerchantsCount = useSelector(getAllMerchantsCount)
  const sortedMerchants = orderBy(merchants, 'name', 'asc')

  const isLoading = useSelector(getIsMerchantsLoading)

  const isModal = !isEmpty(urlQueryParamsState?.merchantUuid)
  // we won't show loader on the list when modal is open
  const isMerchantLoding = isLoading && !isModal

  const handleChangeRowsPerPage = (event) => {
    handleLoadSalesEvents({
      ...queryStringParametersWithVenue,
      page: 1,
      per: Number(event.target.value),
    })
  }

  const handleClickPage = (page) => {
    handleLoadSalesEvents({
      ...queryStringParametersWithVenue,
      page: page,
    })
  }

  const handleLoadSalesEvents = (data) => {
    dispatch(fetchMerchants(data))
    dispatch(setQueryStringParameters(data, pathname))
  }

  return isMerchantLoding ? (
    <Loader />
  ) : (
    <>
      <Section className="item-list section">
        {sortedMerchants?.map((merchant, key) => (
          <ListItem key={key} merchant={merchant} />
        ))}
        <section className="sales-events__pagination">
          <Pagination
            totalItemsCount={totalMerchantsCount}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            handleClickPage={handleClickPage}
            pageNumber={queryStringParameters?.page}
            rowsPerPage={queryStringParameters?.per}
          />
        </section>
      </Section>
      {isModal && <MerchantsForm />}
    </>
  )
}

export default MerchantsList
